<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      eager
      scrollable
      max-width="650px"
      content-class="rounded-dialog"
    >
      <v-form ref="addStrategy" @submit.prevent>
        <v-card>
          <v-card-title dark class="dialog-header">
            <div class="dialog-header-content">
              <div class="dialog-title-wrapper">
                <div class="dialog-icon">
                  <icon name="circle-add" />
                </div>

                <div class="dialog-text">
                  <div class="dialog-title">{{ action }} Strategy</div>

                  <div class="dialog-subtitle">
                    Fill in the required information below
                  </div>
                </div>
              </div>

              <v-btn icon class="close-btn" @click="closeD()">
                <icon name="circle-close" />
              </v-btn>
            </div>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="my-4">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    label="Strategy Description"
                    outlined
                    v-model="strategy_desc"
                    dense
                    :rules="[formRules.required]"
                    class="rounded-lg"
                    color="#6DB249"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-5">
            <v-spacer></v-spacer>

            <v-btn class="btn-cancel" outlined @click="closeD()">
              Cancel
            </v-btn>

            <v-btn
              v-if="action == 'Add'"
              class="btn-save"
              @click="addnew()"
              :disabled="isSubmitLoading"
              :loading="isSubmitLoading"
            >
              Save
            </v-btn>
            <v-btn
              v-if="action == 'Update'"
              class="btn-save"
              @click="update()"
              :disabled="isSubmitLoading"
              :loading="isSubmitLoading"
            >
              Update
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
      :timeout="3000"
    ></fade-away-message-component>
  </div>
</template>

<script>
import icon from "@/assets/icon.vue";
export default {
  components: {
    icon,
  },
  props: {
    data: null,
    action: null,
  },

  data() {
    return {
      id: null,
      spID: null,
      strategy_desc: null,
      target_accomplishment: null,
      linked: null,
      vpList: [],
      dialog: false,
      isSubmitLoading: false,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },
  watch: {
    data: {
      handler(data) {
        this.initialize();
        this.dialog = true;
        console.log("Data", data);
        if (data.id) {
          this.id = data.id;
          this.strategy_desc = data.description;

          this.spID = data.spID;
        } else {
          this.id = null;
          this.strategy_desc = null;
        }
      },

      deep: true,
    },
  },

  methods: {
    initialize() {},

    closeD() {
      this.eventHub.$emit("closeaddStrategy", false);
      this.isSubmitLoading = false;
      this.dialog = false;
    },

    addnew() {
      if (this.$refs.addStrategy.validate()) {
        this.isSubmitLoading = true;
        let data = {
          goalID: this.data.goalID,
          description: this.strategy_desc,
          strat_planID: this.data.strat_planID,
          strategic_outcomeID: this.data.strategic_outcome,
        };
        // console.log(data);
        this.axiosCall(
          "/strategic-planning-goal/addStrategicStrategy",
          "POST",
          data,
        ).then((res) => {
          console.log(res);
          if (res.data.status == 201) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;

            this.closeD();
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        });
      }
    },

    update() {
      console.log("Update Data");
      if (this.$refs.addStrategy.validate()) {
        this.isSubmitLoading = true;
        let data = {
          description: this.strategy_desc,
        };
        // console.log(data);
        this.axiosCall(
          "/strategic-planning-goal/updateStrategicStrategy/" + this.data.id,
          "PATCH",
          data,
        ).then((res) => {
          if (res.data.status == 200) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.closeD();
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        });
      }
    },

    getEmpDetails() {
      this.axiosCall("/employee/my-details", "GET").then((res) => {
        console.log(res.data);
        this.assigned_office = res.data.officeID;
      });
    },

    getOffices() {
      this.axiosCall("/offices", "GET").then((res) => {
        this.officeList = res.data;
      });
    },

    getDesignations() {
      this.axiosCall("/designations", "GET").then((res) => {
        this.designationList = res.data;
      });
    },
  },
};
</script>
